import React, { type FC, type RefObject, useState } from 'react'

import type { FieldProps as FormikFieldProps } from 'formik'
import { useIntl } from 'react-intl'
import type { AnyObjectSchema } from 'yup'

import { IconButton, TextField, type TextFieldProps } from '@themenu/design-system'

import { autoFillInputStyle } from '../../utils/customStyle'
import { isRequiredField } from '../../utils/isRequiredField'

export type FormikFieldInputPasswordProps = TextFieldProps &
  FormikFieldProps & { validationSchema?: AnyObjectSchema; innerRef: RefObject<HTMLInputElement | null> }

export const FormikFieldInputPassword: FC<FormikFieldInputPasswordProps> = ({
  form,
  field,
  validationSchema,
  innerRef,
  ...props
}) => {
  const isRequired = validationSchema ? isRequiredField({ validationSchema, fieldName: field.name }) : props.required
  const [passwordShown, setPasswordShown] = useState(false)

  const showPassword = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault()
    setPasswordShown(!passwordShown)
  }

  const intl = useIntl()
  return (
    <TextField
      ref={innerRef}
      size={56}
      required={isRequired}
      error={form?.touched[field.name] !== undefined && form?.errors[field.name] !== undefined}
      errorMessage={(form?.errors[field.name] as string) || ''}
      {...field}
      {...props}
      style={{ ...props.style, ...autoFillInputStyle(props) }}
      id={field.name}
      type={passwordShown ? 'text' : 'password'}
      suffix={
        <IconButton
          name={passwordShown ? 'eye-close' : 'eye-open'}
          variant="text"
          size={20}
          onClick={showPassword}
          aria-label={intl.formatMessage({
            id: passwordShown
              ? 'sign_in.form.password.icon.hide_password'
              : 'sign_in.form.password.icon.display_password',
          })}
        />
      }
    />
  )
}
